import { withContext } from './withContext';
export function withMeta(key, value) {
    var _a;
    return withContext({ MetaData: (_a = {}, _a[key] = value, _a) });
}
//# sourceMappingURL=withMeta.js.map